export default __webpack_public_path__ + "f45fe8609bd7ebe86e4ec83fe56c19f8.svg";